// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import { GatsbyImage } from 'gatsby-plugin-image';

// Styles
import ImageStyles from './image.styles';

export default function Image({
  image,
  className,
  width,
  height,
  filter,
  background,
  backgroundColor,
  flex,
  alignItems,
  justifyContent,
  loading,
}) {
  const gatsbyImage = image?.gatsbyImage;
  const publicURL = image?.localFile?.publicURL;
  const altText = image?.altText || ' ';

  const displayOptions = image?.mediaDisplayOptions;
  const filterOption = displayOptions?.filter;
  const filterOverride = filter;

  let filterEnabled;

  if (filterOverride === true || filterOverride === false) {
    filterEnabled = filter;
  } else {
    filterEnabled = filterOption;
  }

  if (!gatsbyImage && !publicURL) {
    if (!backgroundColor) return '';

    return (
      <ImageStyles
        backgroundColor={backgroundColor}
        background={background}
        flex={flex}
        alignItems={alignItems}
        justifyContent={justifyContent}
      >
        <div className={className} />
      </ImageStyles>
    );
  }

  return (
    <ImageStyles
      backgroundColor={backgroundColor}
      background={background}
      flex={flex}
      alignItems={alignItems}
      justifyContent={justifyContent}
    >
      {gatsbyImage ? (
        <GatsbyImage
          image={gatsbyImage}
          width={width}
          height={height}
          alt={altText}
          className={`${className} ${filterEnabled ? 'filtered' : ''}`}
          loading={loading}
        />
      ) : (
        <img
          src={publicURL}
          width={width}
          height={height}
          alt={altText}
          className={className}
        />
      )}
    </ImageStyles>
  );
}

Image.propTypes = {
  flex: PropTypes.bool,
  alignItems: PropTypes.string,
  justifyContent: PropTypes.string,
  image: PropTypes.shape({
    id: PropTypes.string,
    altText: PropTypes.string,
    gatsbyImage: PropTypes.shape({}),
    localFile: PropTypes.shape({
      publicURL: PropTypes.string,
    }),
    mediaDisplayOptions: PropTypes.shape({
      filter: PropTypes.bool,
    }),
  }),
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  filter: PropTypes.bool,
  backgroundColor: PropTypes.string,
  background: PropTypes.bool,
  loading: PropTypes.string,
};

Image.defaultProps = {
  className: '',
  width: 100,
  height: 100,
  filter: null,
  backgroundColor: '',
  background: false,
  image: {},
  flex: false,
  alignItems: '',
  justifyContent: '',
  loading: 'lazy',
};
